import { render } from "./LiveTcsInwardTxns.vue?vue&type=template&id=e257666a"
import script from "./LiveTcsInwardTxns.vue?vue&type=script&lang=js"
export * from "./LiveTcsInwardTxns.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2_clean-css@5.3.3_c_e9026addebec4d340c62c6097892aed2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__